module.exports = __webpack_public_path__ + "img/home-med1.b99f762e.jpg";